import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Countdown from "./countdown";

export default function ComingSoon() {
  const { day, hour, min, sec } = Countdown("July 14, 2025");

  return (
    <Box
      sx={{
        textAlign: "center",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: 5,
      }}
    >
      <Typography fontWeight="bold" variant="h6" marginBottom={1}>
        Hello 👋
      </Typography>
      <Typography paragraph>
        You'll see all contestants here shortly.
      </Typography>
      <Typography>
        Stage 1 ends in: <br />{" "}
        <strong>
          {day}d: {hour}h: {min}m: {sec}s
        </strong>
      </Typography>
    </Box>
  );
}
